import "ace-builds/src-noconflict/mode-sparql"
import AceEditor from 'react-ace'
import { connect } from 'react-redux'
import "ace-builds/src-noconflict/mode-perl"
import "ace-builds/src-noconflict/theme-monokai"
import "ace-builds/src-noconflict/theme-solarized_light"

languageMap = {
  'QueryBuilder': 'perl'
  'Sparql': 'sparql'
}

QueryEditor = ({
  mode
  height = '300px',
  width = '100%',
  darkModeEnabled,
  rest...
}) ->

  theme = darkModeEnabled && 'solarized_dark' || 'solarized_light'

  <AceEditor
    onLoad={(editorInstance) ->
      document.addEventListener("mouseover", (e) ->
        editorInstance.resize()
      )
    }
    mode={languageMap[mode]}
    theme={theme}
    fontSize={16}
    showGutter
    highlightActiveLine
    enableBasicAutocompletion
    enableLiveAutocompletion
    enableSnippets
    showPrintMargin={false}
    width={width}
    height={height}
    style={{
      borderRadius: '9px'
      (rest.style or {})...
    }}
    { rest... }
  />

mapStateToProps = ({ explore: { darkModeEnabled }}) -> { darkModeEnabled }

export default connect(mapStateToProps)(QueryEditor)
